import * as Types from './types';
import { createReducer } from '../../utils';

const initialState = {
  loading: false,
  error: null,
  taxConditions: [],
  convertionError: null,
  converted: false,
  mobilePhone: null
};

const seekerGuardReducer = createReducer(initialState)({
  [Types.FETCH_TAX_CONDITIONS]: state => ({ ...state, loading: true, error: null }),
  [`${Types.FETCH_TAX_CONDITIONS}_COMPLETED`]: (state, action) => ({
    ...state,
    loading: false,
    error: null,
    taxConditions: action.payload
  }),
  [`${Types.FETCH_TAX_CONDITIONS}_FAILED`]: (state, action) => ({ ...state, loading: false, error: action.payload }),
  [Types.CONVERT_SEEKER_TO_PUBLISHER]: state => ({ ...state, loading: true, error: null, convertionError: null }),
  [`${Types.CONVERT_SEEKER_TO_PUBLISHER}_COMPLETED`]: (state, action) => ({
    ...state,
    loading: false,
    data: action.payload,
    converted: true
  }),
  [`${Types.CONVERT_SEEKER_TO_PUBLISHER}_FAILED`]: (state, action) => ({
    ...state,
    loading: false,
    convertionError: action.payload.data
  }),
  [`${Types.SET_MOBILE_PHONE}`]: (state, action) => ({
    ...state,
    mobilePhone: action.payload
  }),
  [`${Types.SET_TAX_CONDITIONS}`]: (state, action) => ({
    ...state,
    taxConditions: action.payload
  })
});

export { seekerGuardReducer };
